<script lang="ts">
	import DefaultButton from '../../../../basic/buttons/DefaultButton.svelte';
	import DefaultTextInput from '../../../../basic/input/DefaultTextInput.svelte';
	import InputLabel from '../../../../basic/input/InputLabel.svelte';
	import Modal from '../../../../basic/modal/Modal.svelte';
	import ModalHeader from '../../../../basic/modal/ModalHeader.svelte';
	import { addNotification } from '../../../../notification/Notificationstore';
	import { handleStoreError } from '../../../../stores/GeneralStore';
	import type { CreateSettingDocumentType } from '../../../../types/BasicTypes';
	import { _ } from 'svelte-i18n';

	interface Props {
		onModalClose: () => void;
		createSettingDocumentType: (creationObject: CreateSettingDocumentType) => Promise<void>;
	}

	let { onModalClose, createSettingDocumentType }: Props = $props();

	const creationObject: CreateSettingDocumentType = $state({
		defaultName: '',
		fkDocumentNameGenerator: null
	});

	async function handleCreateSettingDocumentType() {
		if (creationObject.defaultName ? creationObject.defaultName.length <= 2 : true) {
			//Inform the user that we need a min length
			addNotification({
				type: 'info',
				message: $_('settings.basic.document_labels.lbl_name_length')
			});
			return;
		}

		try {
			//Start to create the resource.
			await createSettingDocumentType(creationObject);

			//Hide the modal again.
			onModalClose();
		} catch (error) {
			handleStoreError('settings.basic.document_labels.err_add', error);
		}
	}
</script>

<Modal {onModalClose} onModalEnter={handleCreateSettingDocumentType}>
	{#snippet header()}
		<ModalHeader text={$_('settings.basic.document_labels.lbl_create_header')} />
	{/snippet}
	{#snippet content()}
		<div class="grid gap-2">
			<!--Name-->
			<InputLabel label={$_('settings.basic.document_labels.lbl_name')} />
			<DefaultTextInput
				propertyName=""
				bind:value={creationObject.defaultName}
				focusOnStart={true}
			/>

			<p class="text-sm">
				*{$_('settings.basic.document_labels.lbl_info_generator')}
			</p>
		</div>
	{/snippet}

	{#snippet footer()}
		<div class="flex justify-end gap-4">
			<DefaultButton
				secondary={true}
				text={$_('general.bt_close')}
				onClick={() => {
					onModalClose();
				}}
			/>
			<DefaultButton text={$_('general.lbl_create')} onClick={handleCreateSettingDocumentType} />
		</div>
	{/snippet}
</Modal>
